import { LucideIcon, Sparkles } from "lucide-react"

interface EmptyStateProps {
  icon: LucideIcon
  title: string
  description?: string
  primary?: string
  className?: string
}

export default function EmptyState({ icon: Icon, title, description, primary = 'var(--primary)', className = '' }: EmptyStateProps) {
  return (
    <div className={`w-full flex flex-col items-center text-center gap-5 py-8 sm:py-16 px-6 ${className}`}>
      <div className="relative w-[200px] h-[140px]">
        <div className="absolute inset-x-6 bottom-0 h-3 rounded-full blur-md opacity-30" style={{ background: primary }} />
        <div className="absolute left-3 top-7 w-[88px] h-[108px] rounded-2xl bg-white border border-border -rotate-[8deg] shadow-sm">
          <div className="w-full h-[60%] rounded-t-2xl" style={{ background: `color-mix(in oklch, ${primary} 8%, white)` }} />
          <div className="px-2.5 pt-2 space-y-1.5">
            <div className="h-1.5 rounded-full bg-muted w-3/4" />
            <div className="h-1.5 rounded-full bg-muted w-1/2" />
          </div>
        </div>
        <div className="absolute right-3 top-7 w-[88px] h-[108px] rounded-2xl bg-white border border-border rotate-[8deg] shadow-sm">
          <div className="w-full h-[60%] rounded-t-2xl" style={{ background: `color-mix(in oklch, ${primary} 14%, white)` }} />
          <div className="px-2.5 pt-2 space-y-1.5">
            <div className="h-1.5 rounded-full bg-muted w-2/3" />
            <div className="h-1.5 rounded-full bg-muted w-1/2" />
          </div>
        </div>
        <div className="absolute left-1/2 top-0 -translate-x-1/2 h-16 w-16 rounded-full grid place-items-center shadow-sm border border-border bg-white z-10">
          <Icon className="h-7 w-7" style={{ color: primary }} />
        </div>
        <Sparkles className="absolute -right-1 top-3 h-4 w-4 text-muted-foreground/50" />
      </div>

      <div className="max-w-sm">
        <h3 className="text-[18px] font-semibold tracking-[-0.005em] text-foreground">{title}</h3>
        {description && <p className="text-[13.5px] text-muted-foreground mt-1.5 leading-relaxed">{description}</p>}
      </div>
    </div>
  )
}
